import { render, staticRenderFns } from "./thread-library.vue?vue&type=template&id=3bde7bd2&scoped=true&"
import script from "./thread-library.vue?vue&type=script&lang=js&"
export * from "./thread-library.vue?vue&type=script&lang=js&"
import style0 from "./thread-library.vue?vue&type=style&index=0&id=3bde7bd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bde7bd2",
  null
  
)

component.options.__file = "thread-library.vue"
export default component.exports